import { useEffect, useRef, useState } from "react";
import Image from 'next/image';
import { AccordionTextItemProps } from "./constants"
import { useRouter } from "next/router";


const AccordionText = (props: AccordionTextItemProps) => {
  const router = useRouter();
  const [isOpened, setOpened] = useState<boolean>(false)
  const [height, setHeight] = useState<string>("0px")
  const contentElement = useRef<HTMLDivElement>(null)

  const handleRouteChange = () => {
    setOpened(false);
    setHeight("0px");
  }

  useEffect(() => {
    router.events.on('routeChangeComplete', handleRouteChange)
    return () => {
      router.events.off('routeChangeComplete', handleRouteChange)
    };
  }, [router.events]);

  const HandleOpening = () => {
    setOpened(!isOpened)
    setHeight(!isOpened ? `${contentElement.current!.scrollHeight}px` : "0px")
  }

  return (
    <div>
      <div className={`flex justify-between items-center cursor-pointer ${props.border ? "py-4 border-t border-solid border-reviewBg" : "pb-4"} ${props.bottom_border && isOpened ? "border-b border-solid border-reviewBg" : ""}`} onClick={HandleOpening}>
        <h4 className={props.title_style}>{props.title}</h4>
        <Image
          src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/icons/arrow-down.png"}
          alt="arrow icon"
          width={12}
          height={12}
          quality={100}
          className={`transition-transform ease-in-out duration-300 transform ${isOpened ? "rotate-0" : "-rotate-90"}`}
        />
      </div>
      <div
        ref={contentElement}
        style={{ height: height }}
        className="overflow-hidden transition-all duration-300"
      >
        {props.description.length > 0 && (
          <p className={props.desc_style} dangerouslySetInnerHTML={{__html: props.description.replace(/(?:\r\n|\r|\n)/g, "<br />")}}></p>)
        }
        {props.descriptionElement && props.descriptionElement.length > 0 && (
          <div className="mt-4">
            {props.descriptionElement.map((element, index) => (
              <div key={index} className="mb-4">
                {element}
              </div>
            ))}
          </div>
        )}
        {props.descElement && (
          props.descElement
        )}
      </div>
    </div>
  )
}

export default AccordionText
